/**
 * Search API schemas
 *
 * Export all Zod schemas and types for search-related API endpoints
 */

// Export types from tags
export type {
  TagSearchRequest,
  TagMetadata,
  TagSearchPhoto,
  TagSearchUser,
  TagSearchListing,
  TagSearchSuccessResponse,
  TagSearchErrorResponse,
  TagSearchResponse
} from './tags';

// Export schemas from tags
export {
  TagSearchRequestSchema,
  TagMetadataSchema,
  TagSearchPhotoSchema,
  TagSearchUserSchema,
  TagSearchListingSchema,
  TagSearchSuccessResponseSchema,
  TagSearchErrorResponseSchema,
  TagSearchResponseSchema
} from './tags';

// Export types from listings
export type {
  SearchListingUser,
  SearchListingPhoto,
  SearchListing,
  SearchListingsQuery,
  SearchListingsSuccessResponse,
  SearchListingsErrorResponse,
  SearchListingsResponse
} from './listings';

// Export schemas from listings
export {
  SearchListingUserSchema,
  SearchListingPhotoSchema,
  SearchListingSchema,
  SearchListingsQuerySchema,
  SearchListingsSuccessResponseSchema,
  SearchListingsErrorResponseSchema,
  SearchListingsResponseSchema
} from './listings';

// Export types from home-listings with prefixed names to avoid conflicts
export type {
  HomeListingsRequest,
  ListingPhoto as HomeListingPhoto,
  ListingUser as HomeListingUser,
  HomeListing,
  HomeListingsSuccessResponse,
  HomeListingsErrorResponse,
  HomeListingsResponse
} from './home-listings';

// Export schemas from home-listings with prefixed names to avoid conflicts
export {
  HomeListingsRequestSchema,
  ListingPhotoSchema as HomeListingPhotoSchema,
  ListingUserSchema as HomeListingUserSchema,
  HomeListingSchema,
  HomeListingsSuccessResponseSchema,
  HomeListingsErrorResponseSchema,
  HomeListingsResponseSchema
} from './home-listings';

// Export types from home-showcases with prefixed names to avoid conflicts
export type {
  HomeShowcasesRequest,
  ListingUser as ShowcaseListingUser,
  ListingPhoto as ShowcaseListingPhoto,
  SearchListing as ShowcaseSearchListing,
  HomeShowcasesSuccessResponse,
  HomeShowcasesErrorResponse,
  HomeShowcasesResponse,
  CategoryGroupShowcase
} from './home-showcases';

// Export schemas from home-showcases with prefixed names to avoid conflicts
export {
  HomeShowcasesRequestSchema,
  ListingUserSchema as ShowcaseListingUserSchema,
  ListingPhotoSchema as ShowcaseListingPhotoSchema,
  SearchListingSchema as ShowcaseSearchListingSchema,
  HomeShowcasesSuccessResponseSchema,
  HomeShowcasesErrorResponseSchema,
  HomeShowcasesResponseSchema,
  CategoryGroupShowcaseSchema
} from './home-showcases';

// Export types from similar
export type {
  SimilarListingsQuery,
  SimilarListingsSuccessResponse,
  SimilarListingsErrorResponse,
  SimilarListingsResponse
} from './similar';

// Export schemas from similar
export {
  SimilarListingsQuerySchema,
  SimilarListingsSuccessResponseSchema,
  SimilarListingsErrorResponseSchema,
  SimilarListingsResponseSchema
} from './similar';

// Export types from guides
export type {
  GuideSearchRequest,
  GuideSearchResult,
  GuideSearchSuccessResponse,
  GuideSearchErrorResponse,
  GuideSearchResponse
} from './guides';

// Export schemas from guides
export {
  GuideSearchRequestSchema,
  GuideSearchResultSchema,
  GuideSearchSuccessResponseSchema,
  GuideSearchErrorResponseSchema,
  GuideSearchResponseSchema
} from './guides';
